
import { useNavigate } from "react-router-dom";

export const useNavigationHelpers = () => {
	const navigate = useNavigate();

	const handleBack = () => {
		navigate(-1);
	};

	const handleGoBackToHome = () => {
		navigate("/");
	};

	
	const handleGoTo = (path: string, options?: { replace?: boolean }) => {
		navigate(path, options);
	};

	return { handleBack, handleGoBackToHome, handleGoTo };
};
